import React, { useEffect, useState, useContext, Component } from "react"
import { Link } from "react-router-dom";
import ReactBSAlert from "react-bootstrap-sweetalert";
import { apiEndpoint } from "helpers/url_helper";
import {
    Col,
    Row,
    Card,
    CardBody,
    CardTitle,
    Modal,
    ModalBody,
    ModalHeader,
    Button,
    ModalFooter,
    Dropdown,
  } from "reactstrap"
import {AllUsersListContext} from "components/Common/PageDataContext";
import { useHistory } from 'react-router-dom';
import jwt from "jsonwebtoken";

const DeleteUserModalComponent = (props) => {

    const [modalIsOpen, setModalIsOpen] = useState(false);

    const [alertmsg, setAlert] = useState([]);

    const { usersData, setUsersData } = useContext(AllUsersListContext);
    const [editdeleteuser, seteditdeleteuser] = useState();
    let history = useHistory();    //Style for modal
    const styleModal = {
        "position": 'absolute',
        "top": '40%',
        "left": '50%',
        "transform": 'translate(-50%, -50%)',
        "maxWidth": '40%',
    };

    const toggle = () => {
        setAlert(null);
        setModalIsOpen(!modalIsOpen)
    }
    useEffect(() => {
      const decodedToken = jwt.decode(sessionStorage.getItem("Clear_AuthUser"));
      var UserPermissions=JSON.parse(decodedToken.userRolePermissions);
      // var UserPermissions=JSON.parse(sessionStorage.getItem("UserRolePermissions"));
      seteditdeleteuser(UserPermissions.EditDeleteUser)
    },[])
    const SessionExpired = () => {
      console.log("SessionExpired Called");
      // sessionStorage.removeItem("authUser")
      sessionStorage.removeItem("userFullName")
      sessionStorage.removeItem("Clear_AuthUser")
      sessionStorage.removeItem("GetToChange")
      setAlert(null)
      history.push('/');
    }

    const userDelete = () => {
        // UserValidated
        fetch(apiEndpoint+"/DeleteUserDetails",
            {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "UserID": props.UserData.UserID,
                "UserName": props.UserData.UserName,
                "Token": sessionStorage.getItem("Clear_AuthUser")
            })
            })
            .then(res => res.json())
            .then(
                (result) => {
                    if(result!=undefined)
                    {
                      if(result.status){
                        //sessionStorage.setItem("authUser",JSON.stringify(result.strNewToken))
                        setAlert (
                          <ReactBSAlert
                            success                                          
                            onConfirm={() => toggle()}
                            onCancel={() => setAlert(null)}
                            confirmBtnBsStyle="info"
                          >
                            {result.Message}
                          </ReactBSAlert>
                        )
                        
                        let newdata = usersData.slice();
                        var elindex=newdata.findIndex(someobject => someobject.UserID == props.UserData.UserID);
                        //delete newdata[elindex];
                        newdata.splice(elindex, 1);
                        setUsersData(newdata);
                      }
                      else{
                        if(result.Message == "Session Expired! Please login again and delete user!"){
                        setAlert (
                          <ReactBSAlert
                            warning
                            // title="Campus Selection Is Required!"
                              onConfirm={() => SessionExpired()}
                              onCancel={() => setAlert(null)}
                              confirmBtnBsStyle="info"
                            >
                              {result.Message}
                            </ReactBSAlert>
                          )
                        }
                        else{
                          setAlert(
                            <ReactBSAlert
                              warning
                              // title="Campus Selection Is Required!"
                            onConfirm={() => setAlert(null)}
                            onCancel={() => setAlert(null)}
                            confirmBtnBsStyle="info"
                          >
                            {result.Message}
                          </ReactBSAlert>
                        )
                        }
                      }
                    }
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    //setError(error);
                }
            )
    }

    return (
        <>
            {/* <Link className="btn btn-primary waves-effect waves-light" to="#" role="Button"
            onClick={toggle}><i className="mdi mdi-close-thick"></i></Link> */}
            <Link 
            onClick={toggle}><i className="mdi mdi-close-thick mdi-24px"></i></Link>
            {modalIsOpen==true}
            {alertmsg}
            <Modal isOpen={modalIsOpen} style={styleModal}>
            
                <ModalBody toggle={toggle}>

                    <Row>
                        <h3><center>Are you sure you want to delete user with username "{props.UserData.UserName}"?</center></h3>
                    </Row>

                    <Row>
                      <Col md={3}>
                      </Col>
                      <Col md={4}>
                        <Link className="btn btn-primary waves-effect waves-light" to="#" role="Button"
                        onClick={toggle}>No, cancel!</Link>
                      </Col>
                      <Col md={5}>
                        <button className="btn btn-primary waves-effect waves-light" to="#" role="Button"
                        onClick={userDelete} >Yes, delete it!</button>
                      </Col>

                    </Row>

                </ModalBody>

            </Modal>
        </>
    )

};

export default DeleteUserModalComponent;